<div>
    <div class="duplicate-item-content">
        <h2 style="margin: 5px 0 10px 0;">Duplicate Item</h2>
        <p>You are duplicating {{ data.item.name }} - {{ data.item.tag }}</p>
        <p>Pick a new tag for the duplicated item</p>
    <form [formGroup]="form" novalidate (ngSubmit)="OnSubmit()">
        <div class="container">
            <div>
                <mat-form-field>
                    <input
                        formControlName="tag"
                        matInput
                        pattern="^[A-Z_0-9]*$"
                        placeholder="Item Tag"
                        required
                    >
                    <mat-error *ngIf="form.controls['tag'].invalid && !form.controls['tag'].value">
                        Please enter a New Item Tag
                    </mat-error>
                    <mat-error *ngIf="form.controls['tag'].errors?.pattern && form.controls['tag'].value">
                        Please enter a Valid Item Tag
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div  style="margin-top: 30px;" class="flex-center-center">
            <button
                class="button-color"
                mat-raised-button
                matTooltip="Cancel Duplicating Item"
                style="margin-right: 60px;"
                type="button"
                (click)="onNoClick()"
            >Cancel</button>
            <button
                class="button-color"
                [disabled]="false"
                mat-raised-button
                matTooltip="Submit"
                type="submit"
            >Save</button>
        </div>
    </form>
    </div>
</div>
